import 'core-js';
import 'isomorphic-fetch';

import scrollControl from './services/scrollControl';
import initCookieConsent from './services/cookieConsent';
import observeMenuState from './services/menuStateObserver';
import initTableBars from './services/tableBars';
import initTableShadows from './services/tableShadows';
import initSlickSlider from './services/threatSlickSlider';
import Banner from './services/banner';
import contentMenu from './services/contentMenu';
import { searchParamSaversManager } from './services/searchParams';
import initBlackFridayBanner from './services/blackFridayBanner';
import initWebinarBanner from './services/webinarBanner';

$(document).ready(() => {
  contentMenu();
  observeMenuState();
  initTableBars();
  initTableShadows();
  initCookieConsent();
  scrollControl.init();
  initSlickSlider();
  searchParamSaversManager.init();
  initBlackFridayBanner();
  initWebinarBanner();
});

// const TiYaraBanner = new Banner({
//   templateId: 'ti-lookup-banner',
//   finishDate: '2024-05-14T15:00:00.000Z',
// });

// const springSaleBanner = new Banner({
//   templateId: 'spring-sale-banner',
//   startDate: '2024-05-15T08:00:00.000Z',
//   finishDate: '2024-06-01T06:59:00.000Z',
// });

// const safebrowsingBanner = new Banner({
//   templateId: 'safebrowsing-banner',
//   startDate: '2024-08-15T08:00:00.000Z',
//   finishDate: '2024-10-01T06:59:00.000Z',
// });

const tiWebinarBanner = new Banner({
  templateId: 'ti-webinar-banner',
  finishDate: '2024-10-23T00:00:00.000Z',
})
